// step1-get quote,step2-cover-options, step3-policy-details ,step4-payment

import {
  WireAnalytics,
  WireFormData,
  WirePolicyIssued,
} from 'scenes/common/types';

export enum WireFlowTypeName {
  QuoteDetails = 'get-quote',
  AddDriver = 'get-quote',
  CoverOptions = 'cover-options',
  PolicyDetails = 'policy-details',
  AddPolicyHolder = 'policy-details',
  PaymentDetails = 'payment',
  RetrieveQuote = 'retrieve-quote',
  Unknown = '',
}

export enum WireFlowTypeNumber {
  QuoteDetails = 'step1',
  AddDriver = 'step1',
  CoverOptions = 'step2',
  PolicyDetails = 'step3',
  AddPolicyHolder = 'step3',
  PaymentDetails = 'step4',
  RetrieveQuote = 'retrieve-quote',
  Unknown = '',
}

export type WireCar = {
  searchType: string;
  make: string;
  model: string;
  type: string;
  yearOfManufacture: string;
  overnightParkingPostCode: string;
  carValuation: string;
  agreedValue: string;
  financeStatus: string;
  usage: {
    type: string;
    business: string;
  };
  prevInsurer: {
    name: string;
    levelOfCoverage: string;
  };
  carConditions: {
    modifications: boolean;
    modificationsDetails: string[];
    specialFeatures: boolean;
    damage: boolean;
  };
};

export type WireDriver = {
  gender: string;
  under25: boolean;
  yearOfExperience: string;
  claimNumber: string;
  claimWithExcess: string;
};

export type WireDrivers = WireDriver & {
  additionalDrivers: WireDriver[];
};

export type WireMotorPolicy = {
  optionalExtras: boolean;
  extras: Array<{ name: string }>;
  regoKnown: boolean;
  additionalHolder: boolean;
  startDate: string;
  insuranceHistory: string[];
  includeUnder25: boolean;
  issued: WirePolicyIssued;
};

export type WireEdit = {
  pageName: string;
  sectionName: string;
  subSectionName: string;
};

export type WireMotorFormData = WireFormData & {
  quoteAmountWithExtras: string;
  excessAmount: string;
  policy: WireMotorPolicy;
};

export type WireMotorAnalytics = WireAnalytics & {
  formData: WireMotorFormData;
  car?: WireCar;
  driver?: WireDrivers;
  edit?: WireEdit;
};
